export default "__VITE_ASSET__r5UXt8qt__"